export interface UserEmailSettings {
  receiveAggregation: string | null;
  updatedAt: string | null;
}
